import { jsx as e, jsxs as h } from "react/jsx-runtime";
import { useState as z, useEffect as L } from "react";
import { useTranslation as O, useBreakpoint as G, Breakpoints as m, useMasterData as W, Tooltip as R, Theme as p, IconStyle as $, TooltipPreference as I, Button as T, ButtonWidth as M, ButtonSize as w, ButtonStyles as A, FAIcon as V, Drawer as D } from "@nextgen-web-framework/all";
import k from "../ShareModal/ShareModal.js";
import '../../assets/SocialShareLink.css';const E = "#ffffff", U = "#396e75", Y = "#e5fdff", F = "#546223", q = "#f0fae5", x = "#a65523", H = "#fff1e8", X = "#7f3e3e", K = "#ffe2e2", J = "#62625a", Q = "#f8f8e7", Z = "#38539a", P = "#707070", aa = "#c8f8d1", ea = "#87c9c8", ra = "#5291b1", oa = "rgba(82, 145, 177, 0.1019607843)", ta = "#445685", ia = "#181d61", sa = "rgba(24, 29, 97, 0.1019607843)", la = "#5969d6", da = "#ea999d", na = "#b6577e", ca = "rgba(182, 87, 126, 0.1019607843)", ha = "#7e3e80", ma = "#1e247f", ka = "rgba(30, 36, 127, 0.1019607843)", fa = "#da7600", Ca = "#107f47", _a = "#d91734", za = "_html_1rk3j_38", r = {
  amwayWhite: E,
  darkBlue: U,
  lightBlue: Y,
  darkGreen: F,
  lightGreen: q,
  darkOrange: x,
  lightOrange: H,
  darkRed: X,
  lightRed: K,
  darkYellow: J,
  lightYellow: Q,
  darkPurple: Z,
  darkGrayOnWhite: P,
  dataVizColor1: aa,
  dataVizColor2: ea,
  dataVizColor3: ra,
  dataVizColor3Background: oa,
  dataVizColor4: ta,
  dataVizColor5: ia,
  dataVizColor5Background: sa,
  dataVizColor6: la,
  dataVizColor7: da,
  dataVizColor8: na,
  dataVizColor8Background: ca,
  dataVizColor9: ha,
  dataVizColor10: ma,
  dataVizColor10Background: ka,
  dataVizAlertOrange: fa,
  dataVizSuccessGreen: Ca,
  dataVizWarningRed: _a,
  "no-visible": "_no-visible_1rk3j_34",
  html: za,
  "social-share-link-wrapper": "_social-share-link-wrapper_1rk3j_72",
  "sharebar-drawer-wrapper": "_sharebar-drawer-wrapper_1rk3j_76",
  "share-icon": "_share-icon_1rk3j_85",
  "social-share-modal-wrapper": "_social-share-modal-wrapper_1rk3j_95",
  "share-modal-btn-position": "_share-modal-btn-position_1rk3j_114",
  "share-modal-link-position": "_share-modal-link-position_1rk3j_118",
  "sharebar-close-button": "_sharebar-close-button_1rk3j_122",
  "sharebar-subheader": "_sharebar-subheader_1rk3j_139",
  "sharebar-content-wrapper": "_sharebar-content-wrapper_1rk3j_158",
  "share-modal-mobile-wrapper": "_share-modal-mobile-wrapper_1rk3j_174"
}, ua = ({
  shareRestrictions: g,
  linkProps: o,
  isCustomUrl: t,
  shareTextMessage: i,
  customClass: b,
  buttonProps: a,
  shareDrawer: u,
  showDescription: s,
  shareDescriptionsContent: l,
  shareTitle: S = !0
}) => {
  const [B, j] = z(!1), d = O(), n = G(), N = n === m.XS || n === m.SM, [v, f] = z(!1), c = W("WebshopConfigs").sharebarChannelConfigs, C = () => {
    f(!0);
  }, _ = () => {
    f(!1);
  };
  if (L(() => {
    g && j(!0);
  }, []), B)
    return /* @__PURE__ */ e(
      R,
      {
        iconName: "arrow-up-from-square",
        theme: p.PURPLE,
        iconStyle: $.REGULAR,
        className: `${r["sharebar-share-restrictions"]}`,
        message: d("web.share.restrictions.message"),
        preference: I.TOP_LEFT
      }
    );
  const y = a != null && a.title ? "share-modal-btn-position" : "share-modal-link-position";
  return /* @__PURE__ */ h("div", { className: r["social-share-link-wrapper"], children: [
    u ? /* @__PURE__ */ e("div", { className: `${r["sharebar-drawer-wrapper"]}`, "data-testid": "shareDrawer-test-id", "data-pod-name": "commerce", children: /* @__PURE__ */ e(
      k,
      {
        linkProps: o,
        shareTextMessage: i,
        isCustomUrl: t,
        socialIconsVisibility: c,
        showDescription: s,
        shareDescriptionContent: l
      }
    ) }) : a != null && a.title ? /* @__PURE__ */ e("div", { className: `${r["share-button"]}`, children: /* @__PURE__ */ e(
      T,
      {
        title: a == null ? void 0 : a.title,
        onClick: C,
        theme: (a == null ? void 0 : a.theme) ?? p.BLACK,
        buttonWidth: M.FULL_WIDTH,
        disabled: a == null ? void 0 : a.disabled,
        size: n == m.XS ? w.SMALL : w.MEDIUM,
        buttonStyle: A.SOLID
      }
    ) }) : /* @__PURE__ */ e("div", { className: r["social-share-link"], children: /* @__PURE__ */ e(
      V,
      {
        iconName: "arrow-up-from-square",
        className: `${r["share-icon"]}`,
        onClick: C,
        "data-testid": "shareIcon-test-id",
        "data-pod-name": "commerce"
      }
    ) }),
    v && (N ? /* @__PURE__ */ e(
      D,
      {
        bottomGap: 0,
        header: /* @__PURE__ */ e("div", { children: d("web.share.title") }),
        closeIcon: !0,
        closeOnBackdropClick: !0,
        onClose: _,
        children: /* @__PURE__ */ e("div", { className: r["share-modal-mobile-wrapper"], children: /* @__PURE__ */ e(
          k,
          {
            linkProps: o,
            shareTextMessage: i,
            isCustomUrl: t || !1,
            socialIconsVisibility: c,
            showDescription: s,
            shareDescriptionContent: l
          }
        ) })
      }
    ) : /* @__PURE__ */ h(
      "div",
      {
        className: `${r["social-share-modal-wrapper"]} ${r[y]} ${b}`,
        "data-testid": "share-modal-test-id",
        "data-pod-name": "commerce",
        children: [
          /* @__PURE__ */ h("div", { children: [
            /* @__PURE__ */ e(
              V,
              {
                iconName: "xmark",
                className: `${r["sharebar-close-button"]}`,
                onClick: _,
                "data-testid": "closeButton-test-id",
                "data-pod-name": "commerce"
              }
            ),
            S && /* @__PURE__ */ e("span", { className: `${r["sharebar-subheader"]}`, children: d("web.share.title") })
          ] }),
          /* @__PURE__ */ e(
            k,
            {
              linkProps: o,
              shareTextMessage: i,
              isCustomUrl: t || !1,
              socialIconsVisibility: c,
              showDescription: s,
              shareDescriptionContent: l
            }
          )
        ]
      }
    ))
  ] });
};
export {
  ua as SocialShareLink
};
//# sourceMappingURL=SocialShareLink.js.map
